<template>
  <div class="shop-conditions">
    <ConditionInput
      :value="value"
      @click="
        () => {
          show = true
          $emit('track', 'ShopConditions')
        }
      "
    />
    <Modal v-if="show" :value="value" @input="$ev => $emit('input', $ev)" @close="show = false" />
  </div>
</template>

<script>
import Modal from './Modal'
import ConditionInput from './Input'

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      show: false,
    }
  },
  components: {
    Modal,
    ConditionInput,
  },
}
</script>

<style lang="scss">
.shop-conditions {
  display: flex;

  & > button {
    flex-grow: 1;
  }
}
</style>
